module.exports = __webpack_public_path__ + "img/cover-video.a3ce1fc.jpg";